import styled from "@emotion/styled";

export type MfaSetup = {
  totpURI: string;
  backupCodes: string[];
};

// Column layout shared by the single-action MFA forms. Using a real <form> lets a type="submit"
// button fire on Enter; the matching layout replaces the plain Flex container.
export const MfaForm = styled.form({
  display: "flex",
  flexDirection: "column",
  gap: 16,
});

// Inline field-error text shown beneath an Input (the ui/input Input doesn't render its own errors).
export const ErrorText = styled.span(({ theme }) => ({
  fontSize: "12px",
  color: theme.colors.sysDestructiveDefault,
}));
